import base from "../baseurl";
import token from "../getTk";

const Show = async (companyUuid, userData, userProfileData, employeData) => {
  const tokenA = token.get();
  console.log(companyUuid, userData, userProfileData, employeData);
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const status = await api
    .post("new-users/create", {
      json: { companyUuid, userData, userProfileData, employeData },
    })
    .json();
  console.log(status);
  return status;
};

export default Show;
